import { AppGsvDomainConstant } from "../app-gsv-domain.constant";

export class ConfiguracionSorteoAPIConstant {
  static readonly BASE_URL_ADMINISTRACION: string = "manager/v1/";
  static readonly CREA_CONFIGURACIONSORTEO: string = "draw/save";
  static readonly ACTUALIZA_CONFIGURACIONSORTEO: string = "draw/update";
  static readonly CHANGE_STATUS: string = "draw/status";
  static readonly CHANGE_STATUS_AGREGAR_PARAMETRO: string = "parameter-template/status";
  static readonly CHANGE_STATUS_PARAMETRIZACION_SORTEO: string = "draw-parameter/status";
  static readonly QUERY_BY_COMPANY_CS: string = "draw";
  static readonly QUERY_BY_CRITERIA_PS: string = "schedule/search-by-criteria";
  static readonly QUERY_BY_CRITERIA_PS_RESUMEN: string = "schedule/search-details-by-criteria";
  static readonly QUERY_TIPOS_SORTEOS: string = "departments-config";
  static readonly CREA_PROGRAMACION: string = "schedule";
  static readonly CHANGE_FORMAT_SORT_NAME: string = "schedule/draw-name-format";
  static readonly CHANGE_OBSERVATION_STATUS: string =
    "schedule/observation-status";
  static readonly QUERY_OBSERVATION_SCHEDULE: string = "schedule/observation";
  static readonly CHANGE_SCHEDULE_STATUS: string = "schedule/status";
  static readonly COPIA_PROGRAMACION: string = "schedule/clone";

  static readonly TIPOS_SORTEOS: string = "draw/find-types";
  static readonly QUERY_PARAMETRO_PLANTILLAS: string = "parameter-template/find-by-template-id/";
  static readonly QUERY_PARAMETRIZACION_SORTEO: string = "draw-parameter/all/";
  static readonly CREA_PLAN_RESULTADOS: string = "draw-schedule-plan";
  static readonly QUERY_BY_CRITERIA_PR: string = "draw-schedule-plan/all";
  static readonly CHANGE_STATUS_SCHEDULE_PLAN: string =
    "draw-schedule-plan/status";
  static readonly COPY_SCHEDULE_PLAN: string = "draw-schedule-plan/clone";

  static readonly CREA_LOGOS: string = "logo/save";
  static readonly CREA_PLANTILLAS_CS: string =
    "parameter-template-draw/save-all";
    static readonly CREA_PLANTILLAS_PARAMETRO: string =
    "parameter-template/save-all";

    static readonly CREA_PARAMETRIZACION_SORTEO: string =
    "draw-parameter";

    static readonly ACTUALIZA_PARAMETRIZACION_SORTEO: string =
    "draw-parameter/update";

    static readonly ACTUALIZA_PLANTILLAS_PARAMETRO: string =
    "parameter-template/update";
  static readonly ACTUALIZA_PLANTILLAS_CS: string =
    "parameter-template-draw/update-all";
  static readonly CREA_PLANTILLAS: string = "template/save";
  static readonly CHANGE_STATUS_PLANTILLAS: string = "template/status";
  static readonly ACTUALIZA_PLANTILLAS: string = "template/update";
  static readonly ACTUALIZA_LOGOS: string = "logo/update";
  static readonly IMAGEN_LOGOS: string = "logo";
  static readonly IMAGEN_PARAMETRO_SORTEO: string = "draw-parameter";
  static readonly IMAGEN_PARAMETRO_PLANTILLAS: string = "parameter-template";
  static readonly IMAGEN_PLANTILLAS: string = "template";
  static readonly CHANGE_STATUS_LOGO: string = "logo/change-status";
  static readonly CHANGE_TEMPLATE: string = "draw/update-template";
  static readonly QUERY_BY_LOGO: string = "logo/find-by-criteria";
  static readonly QUERY_BY_PLANTILLA: string = "template/find-by-criteria";
  static readonly QUERY_BY_PV: string = "parameter-template/find-by-template-id";
  static readonly TIPOS_LOGOS: string = "logo/find-types";
  static readonly TIPOS_CAMPOS: string = "parameter/field-types";
  static readonly TIPOS_PARAMETROS_PLANTILLAS: string =
    "template/find-by-criteria";
    static readonly PLANTILLAS_VISUALIZACION_CS: string = 'parameter-template-draw';
  static readonly QUERY_BY_CRITERIA_TIPO_BALOTA: string =
    "type-ballot/parameters";

  static readonly CREA_BALOTERA: string = "ballot-box/ballot";
  static readonly TIPOS_BALOTAS: string = "type-ballot/all-to-list";
  static readonly QUERY_BY_BALOTERAS: string = "ballot-box/all";
  static readonly QUERY_BY_CRITERIA_BALOTERAS: string= "ballot-box/search-by-criteria/";
  static readonly CREA_BALOTERA_PLAN: string = "result-plan-ballot-box/save-all";
  static readonly CHANGE_ORDER_RESULT_PLAN: string = "draw-schedule-plan/update-order";
  static readonly CHANGE_ORDER_BALLOT_BOX_RESULT_PLAN: string = "result-plan-ballot-box/update-order";
  static readonly QUERY_BY_CRITERIA_PLAN_BALOTERAS: string = "result-plan-ballot-box/search-by-criteria";
  static readonly CHANGE_STATUS_PLAN_BALOTERA:string = "result-plan-ballot-box/status";
  static readonly COPY_BALOTERA:string = "ballot-box/";
  static readonly UPDATE_BALOTERA_PLAN_RESULTADOS: string = "result-plan-ballot-box";

  /* static readonly URL_CREA_CONFIGURACIONSORTEO: string =
        AppGsvDomainConstant.URI_GATEWAY_GSV +
        AppBucDomainConstant.BASE_URL_ADMINISTRACION +
        ConfiguracionSorteoAPIConstant.CREA_CONFIGURACIONSORTEO;*/
  
  static readonly URL_CHANGE_ORDER_BALLOT_BOX_RESULT_PLAN: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CHANGE_ORDER_BALLOT_BOX_RESULT_PLAN}`;

  static readonly URL_CHANGE_ORDER_RESULT_PLAN: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CHANGE_ORDER_RESULT_PLAN}`;

  static readonly URL_CREA_CONFIGURACIONSORTEO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_CONFIGURACIONSORTEO}`;

  static readonly URL_CREA_LOGOS: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_LOGOS}`;

  static readonly URL_CREA_PLANTILLAS_CS: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PLANTILLAS_CS}`;

  static readonly URL_CREA_PLANTILLAS_PARAMETRO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PLANTILLAS_PARAMETRO}`;

  static readonly URL_CREA_PARAMETRIZACION_SORTEO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PARAMETRIZACION_SORTEO}`;

  static readonly URL_ACTUALIZA_PARAMETRIZACION_SORTEO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.ACTUALIZA_PARAMETRIZACION_SORTEO}`;

  static readonly URL_ACTUALIZA_PLANTILLAS_PARAMETRO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.ACTUALIZA_PLANTILLAS_PARAMETRO}`;

  static readonly URL_CREA_PLANTILLAS: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PLANTILLAS}`;

  static readonly URL_IMAGEN_LOGOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.IMAGEN_LOGOS;

    static readonly URL_IMAGEN_PARAMETRO_SORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.IMAGEN_PARAMETRO_SORTEO;

     static readonly URL_IMAGEN_PARAMETRO_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.IMAGEN_PARAMETRO_PLANTILLAS;

  static readonly URL_IMAGEN_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.IMAGEN_PLANTILLAS;


  static readonly URL_ACTUALIZA_CONFIGURACIONSORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ACTUALIZA_CONFIGURACIONSORTEO;

  static readonly URL_ACTUALIZA_LOGOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ACTUALIZA_LOGOS;

  static readonly URL_ACTUALIZA_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ACTUALIZA_PLANTILLAS;

  static readonly URL_ACTUALIZA_PLANTILLAS_CS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.ACTUALIZA_PLANTILLAS_CS;

    static readonly URL_QUERY_PLANTILLAS_PARAMETRO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_PARAMETRO_PLANTILLAS;

     static readonly URL_QUERY_PARAMETRIZACION_SORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_PARAMETRIZACION_SORTEO;

  static readonly URL_ALLQUERY_TIPOS_SORTEOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.TIPOS_SORTEOS;

  static readonly URL_ALLQUERY_TIPOS_LOGOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.TIPOS_LOGOS;

  static readonly URL_ALLQUERY_TIPOS_CAMPOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.TIPOS_CAMPOS;

  static readonly URL_ALLQUERY_PARAMETROS_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.TIPOS_PARAMETROS_PLANTILLAS;

    static readonly URL_ALLQUERY_PLANTILLAS_VISUALIZACION: string =
        AppGsvDomainConstant.URI_GATEWAY_GSV +
        AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
        this.PLANTILLAS_VISUALIZACION_CS;

  static readonly URL_ALLQUERY_CONFIGURACION_SORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_COMPANY_CS;

  static readonly URL_ALLQUERY_LOGOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_LOGO;

  static readonly URL_ALLQUERY_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_PLANTILLA;

  static readonly URL_ALLQUERY_TIPOS_PLANTILLAS_VISUALIZACION: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_PV;

  static readonly URL_CHANGE_STATUS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS;

    static readonly URL_CHANGE_STATUS_AGREGAR_PARAMETRO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_AGREGAR_PARAMETRO;

    static readonly URL_CHANGE_STATUS_PARAMETRIZACION_SORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_PARAMETRIZACION_SORTEO;

  static readonly URL_CHANGE_STATUS_LOGO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_LOGO;

    static readonly URL_CHANGE_TEMPLATE: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_TEMPLATE;

    static readonly URL_CHANGE_STATUS_PLANTILLAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_PLANTILLAS

  static readonly URL_CREA_PROGRAMACIONSORTEO: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PROGRAMACION}`;

  static readonly URL_COPIA_PROGRAMACIONSORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    ConfiguracionSorteoAPIConstant.COPIA_PROGRAMACION;

  static readonly URL_ALLQUERY_PROGRAMACION_SORTEO: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_PS;

    static readonly URL_ALL_QUERY_PS_RESUMEN: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_PS_RESUMEN;

  static readonly URL_CHANGE_FORMAT_SORT_NAME: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_FORMAT_SORT_NAME;

  static readonly URL_CHANGE_OBSERVATION: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_OBSERVATION_STATUS;

  static readonly URL_CHANGE_SCHEDULE_STATUS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_SCHEDULE_STATUS;

  static readonly URL_CREA_PLAN_RESULTADOS: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_PLAN_RESULTADOS}`;

  static readonly URL_ALLQUERY_PLAN_RESULTADOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_PR;

  static readonly URL_COPY_SCHEDULE_PLAN: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.COPY_SCHEDULE_PLAN;

  static readonly URL_CHANGE_STATUS_SCHEDULE_PLAN: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_SCHEDULE_PLAN;

  static readonly URL_QUERY_OBSERVATION_SCHEDULE: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_OBSERVATION_SCHEDULE;

  static readonly URL_ALLQUERY_TIPO_BALOTA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_TIPO_BALOTA;

  static readonly URL_CREA_BALOTERA: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_BALOTERA}`;

  static readonly URL_ALLQUERY_TIPOS_BALOTAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.TIPOS_BALOTAS;

  static readonly URL_ALLQUERY_BALOTERAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_BALOTERAS;

  static readonly URL_CREA_BALOTERA_PLAN: string = `${AppGsvDomainConstant.URI_GATEWAY_GSV}${AppGsvDomainConstant.BASE_URL_ADMINISTRACION}${ConfiguracionSorteoAPIConstant.CREA_BALOTERA_PLAN}`;

  static readonly URL_QUERY_BY_CRITERIA_BALOTERAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_BALOTERAS;

  static readonly URL_QUERY_BY_CRITERIA_PLAN_BALOTERAS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.QUERY_BY_CRITERIA_PLAN_BALOTERAS;

  static readonly URL_CHANGE_STATUS_PLAN_BALOTERA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.CHANGE_STATUS_PLAN_BALOTERA;

  static readonly URL_COPY_BALOTERA: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.COPY_BALOTERA;

  static readonly URL_UPDATE_BALOTERA_PLAN_RESULTADOS: string =
    AppGsvDomainConstant.URI_GATEWAY_GSV +
    AppGsvDomainConstant.BASE_URL_ADMINISTRACION +
    this.UPDATE_BALOTERA_PLAN_RESULTADOS;

    public static getAllEndpoints(): string[] {
      return [
          this.URL_CREA_BALOTERA,
          this.URL_CREA_PARAMETRIZACION_SORTEO,
          this.URL_ACTUALIZA_PARAMETRIZACION_SORTEO,
          this.URL_ACTUALIZA_PLANTILLAS_PARAMETRO,
          this.URL_CREA_PLANTILLAS_PARAMETRO,
          this.URL_ACTUALIZA_PLANTILLAS_CS,
          this.URL_CREA_PLANTILLAS_CS,
          this.URL_ACTUALIZA_PLANTILLAS,
          this.URL_CREA_PLANTILLAS,
          this.URL_ACTUALIZA_LOGOS,
          this.URL_CREA_LOGOS,

      ];
  }
}
